import React from "react"
import Script from "next/script"

interface YotpoLoyaltyLoaderProps {
  email?: string
  uid?: string
}
export default function YotpoLoyaltyLoader({
  email,
  uid,
}: YotpoLoyaltyLoaderProps) {
  if (!email || !uid) {
    return null
  }
  return (
    <>
      <div
        id="swell-customer-identification"
        data-authenticated="true"
        data-email={email}
        data-id={uid}
        style={{ display: "none" }}
      />
      <Script
        src={`https://cdn-loyalty.yotpo.com/loader/${process.env.NEXT_PUBLIC_YOTPO_LOYALTY_GUID}.js`}
      />
    </>
  )
}
